// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2dBwE","loaderOuter":"PageOverlayLoader_loaderOuter__2V8yj"};